// extracted by mini-css-extract-plugin
module.exports = {"dark-dialog":"AnimatedDialog-AnimatedDialog-dark-dialog-1nMd3SbF","darkDialog":"AnimatedDialog-AnimatedDialog-dark-dialog-1nMd3SbF"};